import { useRouter } from "next/router";
import { forwardRef } from "react";
import { useUnreadMessages } from "repositories/hooks/useUnreadMessages";
import FavoriteIcon from "shared/assets/icons/FavoriteIcon";
import { HomeIcon } from "shared/assets/icons/HomeIcon";
import { MessageIcon } from "shared/assets/icons/MessageIcon";
import UserIcon from "shared/assets/icons/UserIcon";
import {
  AppNavigation,
  NavIcon,
} from "shared/components/organisms/AppNavigation";
import tw from "twin.macro";

const inactiveIconCss = tw`svg text-secondary`;

const NavIndexes = {
  HOME: 0,
  CHAT_ROOM: 1,
  FAVORITE: 2,
  MYPAGE: 3,
};

interface IconProps {
  active?: boolean;
}

const ChatRoomIcon = (props: IconProps) => {
  const { unreadMessages } = useUnreadMessages();
  return (
    <NavIcon
      icon={<MessageIcon css={!props.active && inactiveIconCss} {...props} />}
      badgeNumber={unreadMessages.count}
    />
  );
};

// iconのpropsの渡し方冗長なので工夫したい
const navigations = [
  {
    label: "ホーム",
    icon: (props: IconProps) => {
      return <HomeIcon css={!props.active && inactiveIconCss} {...props} />;
    },
    pathname: "/",
    index: NavIndexes.HOME,
  },
  {
    label: "チャットルーム",
    icon: ChatRoomIcon,
    pathname: "/chat_rooms",
    index: NavIndexes.CHAT_ROOM,
  },
  {
    label: "お気に入り",
    icon: (props: IconProps) => {
      return <FavoriteIcon css={!props.active && inactiveIconCss} {...props} />;
    },
    pathname: "/favorites",
    index: NavIndexes.FAVORITE,
    authRequired: true,
  },
  {
    label: "マイページ",
    pathname: "/mypage",
    icon: (props: IconProps) => {
      return <UserIcon css={!props.active && inactiveIconCss} {...props} />;
    },
    index: NavIndexes.MYPAGE,
    authRequired: true,
  },
];

interface ActivateNavDictionary {
  [key: string]:
    | typeof NavIndexes.HOME
    | typeof NavIndexes.CHAT_ROOM
    | typeof NavIndexes.FAVORITE
    | typeof NavIndexes.MYPAGE;
}

const activateNavDictionary: ActivateNavDictionary = {
  "/": NavIndexes.HOME,
  "/chat_rooms": NavIndexes.CHAT_ROOM,
  "/favorites": NavIndexes.FAVORITE,
  "/mypage": NavIndexes.MYPAGE,
  "/categories/[alias]": NavIndexes.HOME,
  "/tags/[id]": NavIndexes.HOME,
  "/tags/[id]/fortunes": NavIndexes.HOME,
  "/tags/[id]/tel_fortunes": NavIndexes.HOME,
  "/fortune_tellers/list": NavIndexes.HOME,
  "/fortune_tellers/[id]/reviews": NavIndexes.HOME,
  "/announcements": NavIndexes.HOME,
  "/announcements/[id]": NavIndexes.HOME,
  "/profile/edit": NavIndexes.MYPAGE,
  "/point_histories": NavIndexes.MYPAGE,
  "/coupon_histories": NavIndexes.MYPAGE,
  "/purchase_histories": NavIndexes.MYPAGE,
  "/users/delete_account": NavIndexes.MYPAGE,
  "/users/delete_account/confirm": NavIndexes.MYPAGE,
};

export const UserAppNavigation = forwardRef<HTMLDivElement>((_, ref) => {
  const router = useRouter();
  const { pathname: currentPath } = router;

  const activeNavIndex = activateNavDictionary[currentPath];

  return (
    <AppNavigation
      ref={ref}
      navigations={navigations}
      activeNavIndex={activeNavIndex}
    />
  );
});

UserAppNavigation.displayName = "UserAppNavigation";
